/*
eslint-disable react/prop-types
*/
import React from 'react';
import styled, { withTheme } from 'styled-components/macro';
import { SubWebEvents } from '@uaveiro/ui';


// eslint-disable-next-line no-unused-vars
const SubWebEventsModule = ({ ...props }) => {
  const departmentProps = {
    ...props
  };

  return (
    <Wrapper>
      <SubWebEvents {...departmentProps} />
    </Wrapper>
  )
}

SubWebEventsModule.propTypes = {
};

SubWebEventsModule.defaultProps = {
}

const Wrapper = styled.div`
@media (min-width: 992px)
{
  .order-lg-0 {
      order: 0;
  }
}
`;

export default withTheme(SubWebEventsModule);
